/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCampaignApiModel } from '../../models/create-campaign-api-model';
import { CreateCampaignResponseApiModel } from '../../models/create-campaign-response-api-model';

export interface PassthroughCreate$Params {
  token: string;
      body: CreateCampaignApiModel
}

export function passthroughCreate(http: HttpClient, rootUrl: string, params: PassthroughCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCampaignResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, passthroughCreate.PATH, 'post');
  if (params) {
    rb.path('token', params.token, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateCampaignResponseApiModel>;
    })
  );
}

passthroughCreate.PATH = '/campaigns/passthrough/{token}';
